// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PharmacyBiPbm {
    static getAttributeTypeMap() {
        return PharmacyBiPbm.attributeTypeMap;
    }
}
PharmacyBiPbm.discriminator = undefined;
PharmacyBiPbm.additionalProperties = false;
PharmacyBiPbm.attributeTypeMap = [
    {
        "name": "name",
        "baseName": "name",
        "type": "string"
    },
    {
        "name": "payorName",
        "baseName": "payorName",
        "type": "string"
    },
    {
        "name": "phone",
        "baseName": "phone",
        "type": "string"
    },
    {
        "name": "responseMessage",
        "baseName": "responseMessage",
        "type": "string"
    },
    {
        "name": "specialtyPharmacyRequirement",
        "baseName": "specialtyPharmacyRequirement",
        "type": "string"
    },
];
//# sourceMappingURL=pharmacyBiPbm.js.map